import { Component, EventEmitter, Output } from '@angular/core';
import { Bulto } from 'src/app/interfaces/Bulto';
import { PickupService } from 'src/app/services/pickup.service';
import { ColaBineo, QueueService } from 'src/app/services/queue.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-picker-manual-bultos',
  templateUrl: './picker-manual-bultos.component.html',
  styleUrls: ['./picker-manual-bultos.component.scss'],
})
export class PickerManualBultosComponent {
  bultos: Bulto[] = [];
  bultos_seleccionados: Bulto[] = [];
  bultos_asignados: Bulto[] = [];
  bultos_noasignados: Bulto[] = [];
  @Output() close = new EventEmitter<boolean>();

  constructor(
    public pickupService: PickupService,
    private utilityService: UtilitiesService,
    private queueService: QueueService
  ) {}

  async ngOnInit() {
    let data: { bultos: Bulto[]; status: boolean } =
      await this.pickupService.getBultosPendientes();

    if (!data.status)
      return this.utilityService.showSnackBar(
        'Ha ocurrido un error inesperado, vuelva a ingresar en unos segundos.',
        '#c22'
      );

    const queueData = this.queueService.current_bineo.get(
      this.pickupService.pedidoActivo.sg123
    );
    if (queueData && queueData.length) {
      data.bultos = data.bultos.map((bulto: Bulto) => {
        const colaBineo = queueData.find((cola) => cola.id === bulto.id);
        if (colaBineo) {
          bulto.ubicacion = colaBineo.ubicacion ?? undefined;
          bulto.enCola = true;
        }
        return bulto;
      });
    }
    this.loadBultosList(data.bultos);
  }

  loadBultosList(bultos: Bulto[]) {
    this.bultos_asignados = [];
    this.bultos_noasignados = [];

    this.bultos = bultos.map((bulto: Bulto) => {
      if (bulto.ubicacion) this.bultos_asignados.push(bulto);
      else this.bultos_noasignados.push(bulto);

      return bulto;
    });

    this.pickupService.pedidoActivo.bultos = this.bultos;
  }

  async resetUbicacion(id: any) {
    const bulto: Bulto | undefined = this.bultos_asignados.find(
      (b) => b.id === id
    );
    if (!bulto)
      return this.utilityService.showSnackBar('Bulto no encontrado', '#c22');
    const colaBineoData: ColaBineo[] = [
      {
        id: bulto.id,
        ubicacion: null,
        sg123: bulto.sg123,
        isChecked: false,
      },
    ];
    this.queueService.agregarColaBineoLoop(colaBineoData);
    this.bultos_asignados = this.bultos_asignados.map((b) => {
      if (b.id === id) {
        b.ubicacion = undefined;
        b.isChecked = false;
      }
      return b;
    });

    this.pickupService.pedidoActivo.bultos = [
      ...this.bultos_noasignados,
      ...this.bultos_asignados,
    ];

    this.loadBultosList(this.pickupService.pedidoActivo.bultos);
  }

  async asignarUbicaciones() {
    const colaBineoData: ColaBineo[] = this.bultos_noasignados
      .filter((b) => b.isChecked)
      .map((b) => ({
        id: b.id,
        ubicacion: this.pickupService.codigoPosicion,
        sg123: b.sg123,
        isChecked: b.isChecked ?? false,
      }));
    this.queueService.agregarColaBineoLoop(colaBineoData);

    colaBineoData.forEach((b) => {
      const bulto = this.bultos_noasignados.find((b2) => b2.id === b.id);
      if (bulto) {
        bulto.ubicacion = this.pickupService.codigoPosicion;
        bulto.isChecked = false;
      }
    });

    this.pickupService.pedidoActivo.bultos = [
      ...this.bultos_noasignados,
      ...this.bultos_asignados,
    ];

    this.loadBultosList(this.pickupService.pedidoActivo.bultos);
  }

  seleccionarBulto(id: any) {
    console.log(id);
  }

  salir() {
    this.close.emit(true);
  }
}
